import React from "react";
import { useLang } from "../lib/LangContext";
import { partnerBrands } from "../lib/i18n";

const Marquee = () => {
  const { t } = useLang();
  const items = [...partnerBrands, ...partnerBrands];
  return (
    <section
      data-testid="partners-marquee"
      className="bg-black border-y border-white/10 py-8 md:py-10 overflow-hidden"
    >
      <div className="max-w-screen-2xl mx-auto px-6 md:px-12 lg:px-20 mb-5">
        <div className="flex items-center gap-3">
          <div className="h-px w-8 bg-brand-yellow" />
          <span className="text-[11px] uppercase tracking-[0.4em] text-brand-yellow font-semibold">
            {t.partners.eyebrow}
          </span>
        </div>
      </div>
      <div className="relative w-full overflow-hidden">
        <div className="flex gap-10 md:gap-16 animate-marquee whitespace-nowrap will-change-transform">
          {items.map((b, i) => (
            <span
              key={i}
              className="font-anton uppercase tracking-tight text-transparent"
              style={{ WebkitTextStroke: "1px rgba(255,255,255,0.35)", fontSize: "clamp(2rem, 4vw, 4rem)" }}
            >
              {b}
              <span className="text-brand-yellow ml-10" style={{ WebkitTextStroke: "0" }}>✦</span>
            </span>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Marquee;
